import React from 'react';

import PublicWelcomeContainer from '@src/components/home/PublicWelcomeContainer';

const PublicWelcomePage = () => <PublicWelcomeContainer />;

export default PublicWelcomePage;
